import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import {
  getAdminAccessToken,
  getStoreAccessToken,
  getStoreId,
} from "../../utils/auth";
import { Product, ProductDetail } from "../../types/modules/product.type";

interface UseproductsParams {
  categoryId?: number;
  page?: number;
  limit?: number;
  name?: string;
  storeId?: number;
}

export const useStoreProducts = ({
  categoryId,
  page = 1,
  limit = 10,
  name = "",
  storeId,
}: UseproductsParams) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    name: name?.toString(),
  });

  if (categoryId) {
    queryParams.append("categoryId", categoryId.toString());
  }

  // if admin request the api
  if (storeId) {
    queryParams.append("storeId", storeId.toString());
  }

  const storeIdToSend = storeId ? storeId : getStoreId();

  const token = storeId ? getAdminAccessToken() : getStoreAccessToken();

  return useQuery({
    queryKey: [
      "store-products",
      page,
      limit,
      name,
      categoryId,
      storeIdToSend,
      token,
    ],
    queryFn: () =>
      fetcher<{ data: Product[]; totalPages: number; totalItems: number }>(
        `product/all?${queryParams.toString()}`,
        token
      ),
  });
};

export const useSingleProductDetail = (
  productId: number | null,
  storeId?: number
) => {
  const token = storeId ? getAdminAccessToken() : getStoreAccessToken();
  const endPoint = storeId
    ? `product/${productId}/byStore?storeId=${storeId}`
    : `product/${productId}/byStore`;
  return useQuery({
    queryKey: ["product-detail", productId, storeId],
    queryFn: () => fetcher<ProductDetail>(endPoint, token),
    enabled: !!productId,
  });
};
